import { IAjaxPostConfig } from "./AjaxPost.config";

export { IAjaxPostConfig } from "./AjaxPost.config";

// Custom AjaxPost class to send anti-forgery token in headers
export class AjaxPost {

    private showBackdrop: boolean = false;

    constructor(params: IAjaxPostConfig) {
        let token = $('input[name="__RequestVerificationToken"]').val(),
            headers = {};

        headers['__RequestVerificationToken'] = token;

        if (typeof params.backdrop != 'undefined')
            this.showBackdrop = params.backdrop;

        if (this.showBackdrop) {
            // Clear existing backdrops first
            $(".ajax-backdrop").remove();
            $('#page-preloader').hide();

            $('<div class="modal-backdrop ajax-backdrop fade show"></div>').appendTo(document.body)
            $('#page-preloader').show();
        }

        $.ajax({
            xhr: params.xhr,
            url: params.endpoint,
            dataType: "json",
            type: params.type || "post",
            async: params.async || true,
            contentType: 'application/json; charset=utf-8',
            headers: headers,
            data: params.payload,
            processData: params.processData || true,
            timeout: params.timeout ? params.timeout : 0 //0 is the default value
        })

            .then(function (data) {
                if (params.cbFunction) {
                    params.cbFunction(data);
                }

                $('#page-preloader').hide();
                $(".ajax-backdrop").remove();
            })

            .catch(function (err) {
                if (params.errFunction) {
                    params.errFunction(err);
                    console.error("Error in AjaxPost: ", err);
                }

                $('#page-preloader').hide();
                $(".ajax-backdrop").remove();
            });
    }
}